import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import EmployeeDetailTabPres from '../EmployeeDetail/EmployeeDetailTabPres';
import EmployeeInfoContainer from '../../containers/EmployeeDetail/EmployeeInfoContainer';
import EmployeeCasesContainer from '../../containers/EmployeeDetail/EmployeeCasesContainer';
import Spinner from 'src/ui/library/Spinner/Spinner';
import RelatedEntitiesLanding from 'src/ui/library/RelatedEntities';

export default function EmployeeDetailPres(props) {
  const { tab, header, isLoading, getAdditionalPropsForRelatedEntities, relatedTabs } = props;

  const employeeId = props.match.params.employeeId;

  if (isLoading) {
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="employee-detail-header">
        <Grid container className="header-grid" spacing={0}>
          <Grid item xs={1}>
            <HistoryDisplayContainer history={props.history} type={'white'} />
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Employee name</label>
              <span className="field-text">{header.employeeName}</span>
            </div>
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Employee ID</label>
              <span className="field-text">{header.employeeId}</span>
            </div>
          </Grid>
        </Grid>
      </div>
      <Grid container className="employee-detail-content" spacing={0}>
        <Grid item xs={12} className="employee-detail-tabs">
          <EmployeeDetailTabPres tab={tab} onChange={props.handleTabSelect} relatedTabs={relatedTabs} />
        </Grid>
        <Grid item xs={12} className="employee-detail-body">
          {tab === 'Information' && <EmployeeInfoContainer {...props} />}
          {tab === 'Cases' && <EmployeeCasesContainer {...props} />}
          {tab !== 'Information' && tab !== 'Cases' && (
            <RelatedEntitiesLanding
              key={tab}
              topLevelRecordId={employeeId}
              parentRecordId={employeeId}
              parentEntitySetName="contacts"
              parentEntityName="contact"
              relationshipName={relatedTabs[tab].relationshipName}
              displayName={relatedTabs[tab].displayName}
              additionalProps={getAdditionalPropsForRelatedEntities(relatedTabs[tab].relationshipName)}
              getAdditionalPropsForRelatedEntities={getAdditionalPropsForRelatedEntities}
              area="employees"
            />
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}
